import { useState, useEffect, useCallback } from 'react';
import { Table, TableHeader, TableBody, Column, Row } from 'react-aria-components';
import { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

import { getTemplates } from '@/api/getTemplates';
import Breadcrumbs, { BreadcrumbItem } from '@/components/Breadcrumbs/Breadcrumbs';
import Button from '@/components/Button/Button';
import { CreateOrEditTemplateDialog } from '@/components/templates/CreateOrEditTemplateDialog';
import { Template } from '@/types/template';

export const TemplatesPage = () => {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<Template | undefined>(undefined);
  const [isOpenCreateDialog, setIsOpenCreateDialog] = useState(false);
  const [isEditOpenDialog, setIsEditOpenDialog] = useState(false);

  const { pathname: pathName } = useLocation();
  const breadcrumbs: BreadcrumbItem[] = [{ path: pathName, name: '定型文マスタ' }];

  const fetchTemplates = useCallback(async () => {
    try {
      const result = await getTemplates();
      if (result.status === 200) {
        setTemplates(result.result);
      }
    } catch (error) {
      console.log('error');
    }
  }, []);

  useEffect(() => {
    fetchTemplates();
  }, []);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <Breadcrumbs item={breadcrumbs} />
      </div>
      <div className="mb-4 mt-5 flex flex-col items-start justify-between gap-5">
        <h1 className="text-2xl font-bold">定型文マスタ</h1>
        <div className="flex-shrink-0">
          <Button
            type="submit"
            size="lg"
            variant="solid-fill"
            onClick={() => setIsOpenCreateDialog(true)}
          >
            新規登録
          </Button>
        </div>
      </div>
      {isOpenCreateDialog && (
        <CreateOrEditTemplateDialog
          isOpen={isOpenCreateDialog}
          setIsOpen={setIsOpenCreateDialog}
          afterSubmit={() => {
            fetchTemplates();
          }}
        />
      )}

      <Table className="w-full border-collapse border border-gray-200">
        <TableHeader>
          <Column
            isRowHeader
            className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium"
          >
            No
          </Column>
          <Column
            isRowHeader
            className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium"
          >
            カテゴリ
          </Column>
          <Column className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium">
            定型文
          </Column>
          <Column className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium">編集</Column>
        </TableHeader>
        <TableBody>
          {templates.map((template, index) => (
            <Row key={index}>
              <Column
                key="no"
                className="border border-gray-200 px-4 py-2 font-medium"
              >
                {template.id}
              </Column>
              <Column
                key="category"
                className="border border-gray-200 px-4 py-2 font-medium"
              >
                {template.category}
              </Column>
              <Column
                key="templateBody"
                className="border border-gray-200 px-4 py-2 font-medium"
              >
                {template.body}
              </Column>

              <Column
                key="edit"
                className="border border-gray-200 px-4 py-2"
              >
                <Button
                  size="sm"
                  variant="text"
                  type="submit"
                  onClick={() => {
                    setIsEditOpenDialog(true);
                    setSelectedTemplate(template);
                  }}
                >
                  編集
                </Button>
              </Column>
            </Row>
          ))}
        </TableBody>
      </Table>
      {isEditOpenDialog && (
        <CreateOrEditTemplateDialog
          isOpen={isEditOpenDialog}
          setIsOpen={setIsEditOpenDialog}
          afterSubmit={() => {
            fetchTemplates();
          }}
          template={selectedTemplate}
        />
      )}
      <Toaster />
    </div>
  );
};
